import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContingencyEventDetail } from "../../../types/dte/contingency/ContingencyEventDetail";
import { ContingencyEventTable } from "../../../types/dte/contingency/ContingencyEventTable";

interface ContingencyEventState {
  list: ContingencyEventTable[];
  paginator: any;
  pageSize: number;

  detail: ContingencyEventDetail | null;
  detailLoaded: boolean;

  loading: boolean;
}

const initialState: ContingencyEventState = {
  list: [],
  paginator: null,
  pageSize: 10,

  detail: null,
  detailLoaded: false,

  loading: false,
};

const contingencyEventSlice = createSlice({
  name: "contingencyEvent",
  initialState,
  reducers: {

    /** 📄 Cargar lista paginada */
    setContingencyEventList(
      state,
      action: PayloadAction<{ content: ContingencyEventTable[] } & any>
    ) {
      state.list = action.payload.content;
      state.paginator = action.payload;
    },

    /** ♻️ Limpiar tabla */
    clearContingencyEventList(state) {
      state.list = [];
      state.paginator = null;
    },

    /** 📌 Cambiar tamaño de página */
    setContingencyEventPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload;
    },

    /** 🔍 Establecer detalle cargado */
    setContingencyEventDetail(state, action: PayloadAction<ContingencyEventDetail | null>) {
      state.detail = action.payload;
      state.detailLoaded = action.payload !== null;
    },

    clearContingencyEventDetail(state) {
      state.detail = null;
      state.detailLoaded = false;
    },

    /** ⏳ Control de carga */
    setContingencyEventLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const {
  setContingencyEventList,
  clearContingencyEventList,
  setContingencyEventPageSize,
  setContingencyEventDetail,
  clearContingencyEventDetail,
  setContingencyEventLoading,
} = contingencyEventSlice.actions;

export default contingencyEventSlice.reducer;
